// extracted by mini-css-extract-plugin
export var container = "SegmentedControl-module--container--9216e";
export var segment = "SegmentedControl-module--segment--48f27";
export var selected = "SegmentedControl-module--selected--8c4b6";